import React, { useState } from "react";
import PropTypes from "prop-types";
import "./Range.scss";
import ToolTip from "../ToolTip/ToolTip";
import { FormatAsThousands } from "../../../utils/Helpers/Format";
import { FormattedMessage } from "react-intl";

const Range = (props) => {
  const {
    id,
    value,
    handler,
    label,
    rangeMin,
    rangeMax,
    rangeStep,
    description,
    tooltip,
    ariaControls,
    hasSupportingInfoBelow,
    disabled,
    showLimits,
  } = props;

  const [workingValue, setWorkingValue] = useState(value);
  const [prevValue, setPrevValue] = useState(null);

  const metricValue = process.env.REACT_APP_METRIC_SYSTEM ? (
    <FormattedMessage
      id="vehicle.kilometers"
      defaultMessage="kilometers"
      description="kilometers"
    />
  ) : (
    <FormattedMessage
      id="vehicle.miles"
      defaultMessage="miles"
      description="miles"
    />
  );

  if (value !== prevValue) {
    setWorkingValue(value);
    setPrevValue(value);
  }

  return (
    <div
      className="form-group"
      style={{
        marginTop: "8px",
        marginBottom: hasSupportingInfoBelow ? "4px" : "1rem",
      }}
    >
      {label && (
        <label className="label-range" htmlFor={id} id={id + '-help'}>
          {label}
          {tooltip && <ToolTip message={tooltip} id={id + "_tooltip"} />}
        </label>
      )}
      <input
        type="range"
        aria-label={label || "Range slider"}
        id={id}
        className="form-control-range input-range"
        value={workingValue}
        min={rangeMin}
        max={rangeMax}
        step={rangeStep}
        disabled={disabled}
        aria-controls={ariaControls}
        // On change, set workingState:
        onChange={(e) => setWorkingValue(e.target.value)}
        // When finished changing, set global app state:
        onMouseUp={(e) => handler(e)}
        onKeyUp={(e) => handler(e)}
        onTouchEnd={(e) => handler(e)}
      />
      <div className="range-description">
        {showLimits && (
          <p className="mb-0">
            {FormatAsThousands(rangeMin) + " "}
            {metricValue}
          </p>
        )}
        {description && (
              <p className="mb-0 main-text">{description(workingValue)}</p>
        )}
        {showLimits && (
          <p className="mb-0">
            {FormatAsThousands(rangeMax) + " "}
            {metricValue}
          </p>
        )}
      </div>
    </div>
  );
};

export default Range;

Range.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handler: PropTypes.func,
  label: PropTypes.string,
  rangeMin: PropTypes.number,
  rangeMax: PropTypes.number,
  rangeStep: PropTypes.number,
  description: PropTypes.func,
  disabled: PropTypes.bool,
  hasSupportingInfoBelow: PropTypes.bool,
  ariaControls: PropTypes.string,
  tooltip: PropTypes.string,
};
